<template>
	<div>
		<div>
			<div class="setHeight">
				<div class="wjTypeChild" :style="{ height: height + 'px' }" style="overflow-y: hidden; position: fixed; top: 61px; z-index: 111;
	border-right: 1px solid #ccc;">
					<div
						v-for="(operate, index) in tx_setting"
						:key="operate.id"
						style="text-align: center"
						class="wjTypeChildItemFont"
						:class="{
							wjTypeChildItem: index != 0,
							iconActive: index == selectIndex
						}"
						@click="selectIcon(index, operate.id)"
					>
						<router-link :to="{ path: operate.path, query: { typeId: operate.id } }" v-show="operate.show">
							<div class="icon activebox_box">
								<img :src="operate.icon2" v-if="index == selectIndex" style="margin-top: 12px" class="activebox_box_img1" alt="" />
								<img class="activebox_box_img2" :src="operate.icon" v-else style="margin-top: 12px !important" />
							</div>
							<span  class="iconSpan">{{ operate.label }}</span>
						</router-link>
					</div>
				</div>
			</div>
		</div>
		<div style="padding-left: 82px;">
			<keep-alive><router-view ref="content"></router-view></keep-alive>
		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {
			permissionList: {},
			tx_setting: [
				{
					id: '1',
					label: this.$t('main.QuestionType'),
					icon: require('../assets/tx/tab_def_icon1.png'),
					icon2: require('../assets/tx/tab_sel_icon1.png'),
					path: '/questionType',
					show:true,
				},
				// {
				//   id: "2",
				//   label: "题库",
				//   icon: require("../assets/tx/tab_def_icon2.png"),
				//   icon2: require("../assets/tx/tab_sel_icon2.png"),
				//   // path: "/questionBank",
				//   path: "/questionType",
				// 	show:true,
				
				// },
				// {
				//   id: "3",
				//   label: "逻辑",
				//   icon: require("../assets/tx/tab_def_icon3.png"),
				//   icon2: require("../assets/tx/tab_sel_icon3.png"),
				//   path: "/logic",
				// 	show:true,
				// },
				{
					id: '4',
					label: this.$t('main.Appearance'),
					icon: require('../assets/tx/tab_def_icon4.png'),
					icon2: require('../assets/tx/tab_sel_icon4.png'),
					path: '/appearance',
					show:true,
				},
				// {
				// 	id: '6',
				// 	label: this.$t('PublishProject.TelephoneSurveys'),
				// 	icon: require('../assets/tx/tab_phone.png'),
				// 	icon2: require('../assets/tx/tab_phone1.png'),
				// 	path: '/telecommunications',
				// 	show: false
				// },

				// {
				// 	id: '7',
				// 	label: this.$t('PublishProject.Interview'),
				// 	icon: require('../assets/tx/interview.png'),
				// 	icon2: require('../assets/tx/interview1.png'),
				// 	path: '/discussPersonally',
				// 	show: false
				// },
				{
					id: '5',
					label: this.$t('main.setUp'),
					icon: require('../assets/tx/tab_def_icon5.png'),
					icon2: require('../assets/tx/tab_sel_icon5.png'),
					path: '/questionSetting',
					show:true,
				}
			],
			selectTypeIndex: 0,
			height: 0,
			selectIndex: 0
		};
	},
	mounted() {
		this.selectIndex = sessionStorage.getItem('index') || 0;
		this.selectIcon(this.selectIndex)
		var winHeight = document.body.clientHeight || document.documentElement.clientHeight;
		this.height = winHeight - 108;
		this.rightheight = winHeight - 60;
		window.onresize = () => {
			var winHeight = document.body.clientHeight || document.documentElement.clientHeight;
			this.height = winHeight - 108;
			this.rightheight = winHeight - 60;
		};
	},
	created() {
		this.accessPermission();
	},
	methods: {
		accessPermission() {
			let userInfo = JSON.parse(window.localStorage.getItem('userInfo'));
			// console.log(userInfo.permissionList);
			let arr = userInfo.permissionList;
			let permissionList = {};
			arr.forEach((item, index) => {
				permissionList['admin' + item] = item;
			});
			// this.permissionList = permissionList;
			this.tx_setting.forEach(item=>{
				if(permissionList.admin1006){
					if(item.id == 4){
						item.show = true
					}
				}else{
					if(item.id == 4){
						item.show = false
					}
				}
				
				if(permissionList.admin1007){
					if(item.id == 5){
						item.show = true
					}
				}else{
					if(item.id == 5){
						item.show = false
					}
				}
				
				// 电访
				if (permissionList.admin1010) {
					if (item.id == 6) {
						item.show = true;
					}
				} else {
					if (item.id == 6) {
						item.show = false;
					}
				}
				// 面访
				if (permissionList.admin1011) {
					if (item.id == 7) {
						item.show = true;
					}
				} else {
					if (item.id == 7) {
						item.show = false;
					}
				}
			})
			
		},
		selectIcon(index, id) {
			this.selectIndex = index;
			sessionStorage.setItem('index', index);
		}
	},
	beforeDestroy() {
		sessionStorage.setItem('index', '');
	}
};
</script>

<style scoped>
.iconActive span {
	color: #0080ff;
}
.iconActive .icon {
	background-color: #0080ff;
}
.wjTypeChild {
	width: 80px;
	background-color: #fff;
	padding-top: 15px;
	padding-bottom: 30px;
	float: left;
	display: inline;
	/* border-right: 2px solid #ccc; */
}
.wjTypeChildItem {
	text-align: center;
	margin-top: 40px;
}
.icon {
	margin: 0px auto;
	width: 50px;
	height: 50px;
	border-radius: 5px;
}
.wjTypeChildItemFont {
	font-size: 14px;
	cursor: pointer;
}
.iconSpan {
	display: block;
	color: #666;
}
.setHeight {
	width: 80px;
	height: 100%;
	background-color: #fff;
	margin-top: 1px;
}
</style>
